import {z} from "zod";
import {SOURCES} from "../templates/templateFormSchema";

export const SNIPPET_LANGUAGES = ["en", "es"] as const;

export const snippetFormSchema = z.object({
  name: z.string().min(1, "Required"),
  element_name: z.string(),
  source: z.enum(SOURCES),
  language: z.enum(SNIPPET_LANGUAGES),
  source_snippet_id: z.number().nullable(),
  translation_snippet_id: z.number().nullable(),
  body: z.string().min(1, "Required"),
});

export type SnippetFormValues = z.infer<typeof snippetFormSchema>;

export const EMPTY_SNIPPET: SnippetFormValues = {
  name: "",
  element_name: "",
  source: "manual",
  language: "en",
  source_snippet_id: null,
  translation_snippet_id: null,
  body: "",
};
